function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
(function ($) {
  function isDesktop() {
    return typeof XTSThemeModule !== 'undefined' && XTSThemeModule.isDesktopSize;
  }
  function patchCarouselArgsForInit($root) {
    if ($root.hasClass('xts-inited')) {
      return false;
    }
    var raw = $root.attr('data-carousel-args');
    if (!raw) {
      return false;
    }
    var data;
    try {
      data = JSON.parse(raw);
    } catch (e) {
      return false;
    }
    if (!data.carousel_items || typeof data.carousel_items.size !== 'number') {
      return false;
    }

    // xts skips swiper init on desktop when items <= carousel_items; we always want the
    // fixed-width peek carousel (arrows + cut-off), so lower the size below the item count.
    var size = data.carousel_items.size;
    var n = $root.find('.xts-col').length;
    if (!isDesktop() || n === 0 || n > Math.floor(size)) {
      return false;
    }
    if (!$root.attr('data-carousel-args-original')) {
      $root.attr('data-carousel-args-original', raw);
    }
    var patched = $.extend(true, {}, data);
    patched.carousel_items = $.extend({}, patched.carousel_items, {
      size: Math.max(n - 0.001, 0.5)
    });
    $root.removeData('carousel-args');
    $root.attr('data-carousel-args', JSON.stringify(patched));
    return true;
  }
  function carouselSpacingPx(data) {
    if (!data || typeof data.carousel_spacing === 'undefined') {
      return 20;
    }
    var raw = data.carousel_spacing;
    var n = _typeof(raw) === 'object' && raw !== null && typeof raw.size !== 'undefined' ? Number(raw.size) : Number(raw);
    if (!Number.isNaN(n) && n >= 0) {
      return n;
    }
    return 20;
  }
  function applySwiperSpaceBetweenFromData(swiper, data) {
    if (!swiper || !data) {
      return;
    }
    var spacing = carouselSpacingPx(data);
    swiper.params.spaceBetween = spacing;
    swiper.params.roundLengths = true;
    swiper.params.allowTouchMove = true;
    swiper.params.simulateTouch = true;
    swiper.params.resistanceRatio = 0;
    var bps = swiper.params.breakpoints;
    if (!bps || _typeof(bps) !== 'object') {
      return;
    }
    Object.keys(bps).forEach(function (key) {
      var block = bps[key];
      if (block && _typeof(block) === 'object') {
        block.spaceBetween = spacing;
      }
    });
  }
  function applySlidesPerViewFromData(swiper, original) {
    if (!swiper || !original || !original.carousel_items) {
      return;
    }
    var mob = Number(original.carousel_items_mobile.size);
    var tab = Number(original.carousel_items_tablet.size);
    var desk = Number(original.carousel_items.size);
    if (Number.isNaN(mob) || Number.isNaN(tab) || Number.isNaN(desk)) {
      return;
    }
    var mobInt = Math.max(1, Math.floor(mob));
    var tabInt = Math.max(1, Math.floor(tab));
    swiper.params.slidesPerView = mobInt;
    swiper.params.slidesPerGroup = 1;
    var bps = swiper.params.breakpoints;
    if (!bps || _typeof(bps) !== 'object') {
      swiper.update();
      return;
    }
    Object.keys(bps).forEach(function (key) {
      var bp = parseInt(key, 10);
      var block = bps[key];
      if (!block || _typeof(block) !== 'object') {
        return;
      }
      if (bp >= 1025) {
        block.slidesPerView = desk;
      } else if (bp >= 768) {
        block.slidesPerView = tabInt;
        block.slidesPerGroup = 1;
      } else {
        block.slidesPerView = mobInt;
        block.slidesPerGroup = 1;
      }
    });
    swiper.update();
  }

  // Slides in these containers get fixed CSS widths >=1025px (product-loop-carousel-peek.css),
  // overriding Swiper's computed sizes. 'auto' makes Swiper measure the real widths so the
  // end snap is exact and the last slide stays reachable.
  function applyAutoSlideWidths($root, swiper) {
    if (!$root.closest('.elementor-widget-xts_products, section.related.products, section.upsells.products, section.up-sells.products').length) {
      return;
    }
    if (isDesktop()) {
      swiper.params.slidesPerView = 'auto';
    }
    var bps = swiper.params.breakpoints;
    if (bps && _typeof(bps) === 'object') {
      Object.keys(bps).forEach(function (key) {
        var block = bps[key];
        if (block && _typeof(block) === 'object' && parseInt(key, 10) >= 1025) {
          block.slidesPerView = 'auto';
        }
      });
    }
    swiper.update();
  }
  function syncProductCarouselSwiper($root) {
    var raw = $root.attr('data-carousel-args');
    if (!raw) {
      return;
    }
    var data;
    try {
      data = JSON.parse(raw);
    } catch (e) {
      return;
    }
    var $container = $root.find('> .swiper-container');
    var el = $container[0];
    if (!el || !el.swiper) {
      return;
    }
    var swiper = el.swiper;
    applySwiperSpaceBetweenFromData(swiper, data);
    var rawOrig = $root.attr('data-carousel-args-original');
    if (rawOrig) {
      try {
        applySlidesPerViewFromData(swiper, JSON.parse(rawOrig));
      } catch (e2) {
        swiper.update();
      }
      applyAutoSlideWidths($root, swiper);
      return;
    }
    swiper.params.slidesPerGroup = 1;
    var bps = swiper.params.breakpoints;
    if (bps && _typeof(bps) === 'object') {
      Object.keys(bps).forEach(function (key) {
        if (parseInt(key, 10) < 1025) {
          var block = bps[key];
          if (block && _typeof(block) === 'object') {
            block.slidesPerGroup = 1;
          }
        }
      });
    }
    swiper.update();
    applyAutoSlideWidths($root, swiper);
  }
  function syncAllProductCarousels() {
    $('.xts-products.xts-carousel.xts-lib-swiper.xts-inited').each(function () {
      syncProductCarouselSwiper($(this));
    });
  }
  function runPatchAndReinit() {
    if (typeof XTSThemeModule === 'undefined' || !XTSThemeModule.carouselInitSwiper) {
      return;
    }
    $('.xts-carousel.xts-lib-swiper').each(function () {
      patchCarouselArgsForInit($(this));
    });
    XTSThemeModule.carouselInitSwiper();
    requestAnimationFrame(function () {
      syncAllProductCarousels();
      requestAnimationFrame(syncAllProductCarousels);
    });
    setTimeout(syncAllProductCarousels, 120);
  }
  function whenXtsReady(fn) {
    if (typeof XTSThemeModule !== 'undefined' && XTSThemeModule.carouselInitSwiper) {
      fn();
      return;
    }
    var n = 0;
    var id = setInterval(function () {
      n += 1;
      if (typeof XTSThemeModule !== 'undefined' && XTSThemeModule.carouselInitSwiper) {
        clearInterval(id);
        fn();
      } else if (n > 60) {
        clearInterval(id);
      }
    }, 50);
  }
  function bindRestoreOnImagesLoaded() {
    if (typeof XTSThemeModule === 'undefined' || !XTSThemeModule.$document) {
      return;
    }
    var t;
    XTSThemeModule.$document.on('xtsImagesLoaded', function () {
      clearTimeout(t);
      t = setTimeout(syncAllProductCarousels, 80);
    });
  }
  $(function () {
    whenXtsReady(function () {
      runPatchAndReinit();
      bindRestoreOnImagesLoaded();
    });
  });
})(jQuery);